const DIRECTIVE_NAME = HierarchicalPaymentCodeValidator.DIRECTIVE_NAME = 'ktHierarchicalPaymentCodeValidator';
const VALIDITY_NAME = 'IsValid';
export default function HierarchicalPaymentCodeValidator() {
    return {
        restrict: 'A',
        require: ['ngModel'],
        link: function($scope, $elem, $attrs, [ngModelCtrl]) {
            $scope.$watch(getModelValue, validate, true);

            function validate(isValid) {
                ngModelCtrl.$setValidity(VALIDITY_NAME, isValid);
            }

            function getModelValue() {
                return $scope.$eval($attrs[DIRECTIVE_NAME]);
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-container/payment-codes-list/hierarchical-payment-codes/hierarchical-payment-code-validator.js